import { QueryObserverOptions } from "@tanstack/react-query"

import { Duration } from "@shared/types/duration"
import {
  MedicalResultLabResultResponse,
  MedicalResultLetterResponse,
  MedicalResultMedicationsResponse,
} from "@shared/zod/schemas/responses/medicalResults"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"
import { makeFileInstance } from "./generic/FileInstance"

// Sets defaults used in `buildApiFromServices`.
// Avoid refetching too often. The medical files do not change that often
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: Duration.from("30 minutes").milliseconds,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchInterval: false,
}

export const labResults = async (): Promise<MedicalResultLabResultResponse[]> => {
  const resp = await axiosPatient({
    url: "/patient/medicalresults/labresults",
    method: "get",
  })
  return resp.data
}

export const letters = async (): Promise<MedicalResultLetterResponse[]> => {
  const resp = await axiosPatient({
    url: "/patient/medicalresults/letters",
    method: "get",
  })
  return resp.data
}

export const medications = async (): Promise<MedicalResultMedicationsResponse[]> => {
  const resp = await axiosPatient({
    url: "/patient/medicalresults/medications",
    method: "get",
  })
  return resp.data
}

export const downloadLetter = async (letterId: string) => {
  const result = await axiosPatient({
    url: `/patient/medicalresults/letters/${letterId}/download`,
    method: "get",
    responseType: "blob",
  })
  return makeFileInstance(result)
}
